import { alertDialog, confirmDialog, informationDialog, successDialog, warningDialog } from "../base";

/** @deprecated use alertDialog */
export const alert = alertDialog;

/** @deprecated use confirmDialog */
export const confirm = confirmDialog;

/** @deprecated use informationDialog */
export const information = informationDialog;

/** @deprecated use successDialog */
export const success = successDialog;

/** @deprecated use warningDialog */
export const warning = warningDialog;